import {useAuthStore} from "@/store/auth";
import {kapitelErrorHandler} from "@/helper/error";
import {mergeDeep} from "@/helper/object";

export const fetchWithAuth = async (url: string, body: BodyInit | null, method: string = 'GET', headers: object = {}, {useImpersonation} : {useImpersonation: boolean} = {useImpersonation: true}) => {
    const authStore = useAuthStore();

    if (!authStore.hasToken()) {
        throw Error("No employee token found.")
    }

    const authHeaders = {
        "Authorization": "Bearer " + authStore.getToken(),
        "X-Switch-User": authStore.isImpersonating() && useImpersonation ? authStore.getImpersonationUsername() : ""
    }

    try {
        return await fetchWithRetry(url, {
            method,
            headers: {
                ...authHeaders,
                ...headers
            },
            body
        });
    } catch (error: any) {
        kapitelErrorHandler(error)
        throw error;
    }
}

import fetchRetryBuilder from 'fetch-retry'

// fetch-retry is used the same way as fetch, but also accepts retries, retryDelay, and retryOn on the options object.
export const FetchRetryOptions = {
    retryDelay: 200,
    retries: 1,
    // retryOn: ... - The default behavior of fetch-retry is to only retry requests on network related issues
}
export const fetchWithRetry = fetchRetryBuilder(fetch, FetchRetryOptions)
